module.exports = __webpack_public_path__ + "img/category-skill-game-hover.248e8ba8.png";